import { useEffect, useState } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";

import Button from 'components/generics/Button';
import OutlinedButton from "components/generics/OutlinedButton";
import BlockBox from "components/generics/BlockBox";
import ReactMarkdown from "components/generics/ReactMarkdown";

function Articles({
    articles,
    styles
}) {
    const articleList = articles.article_list;
    const total = articleList.length;
    const pageSize = 3;

    const [current, setCurrent] = useState(0);
    const [pgArticles, setPgArticles] = useState([]);

    const handlePagination = () => {
        const available = total - current;

        if (available) {
            if (available >= pageSize) {
                setCurrent(current + pageSize);
            } else {
                setCurrent(current + available);
            }
        } else {
            setCurrent(current - pageSize);
        }
    }

    useEffect(() => {
        handlePagination();
    }, [])

    useEffect(() => {
        setPgArticles(articleList.slice(0, current));
    }, [current,])

    return (
        <>
            <BlockBox
                backgroundColor="#fff"
            >
                <div className={styles.articleContainer}>

                    <Typography
                        variant="h2"
                        className="center"
                    >
                        {articles.title}
                    </Typography>

                    <div className={styles.articleListContainer}>
                        {
                            pgArticles && pgArticles.map((article, index) => (
                                <Card
                                    elevation={0}
                                    key={index}
                                    className={styles.articleCard}
                                >
                                    {/* <div className={clsx("flex-row",)}> */}
                                    <CardMedia
                                        className={styles.articleImage}
                                        image={article.image}
                                    />
                                    <CardContent className={styles.articleContent}>
                                        <Typography
                                            color="textSecondary"
                                        >
                                            {article.brand}
                                        </Typography>
                                        <Typography
                                            variant="h5"
                                            className="ptb5"
                                        >
                                            {article.title}
                                        </Typography>
                                        <ReactMarkdown
                                            className="justify"
                                            source={article.description}
                                        />
                                        <div
                                            className={styles.readMoreBtn}
                                        >
                                            <OutlinedButton>
                                                <a
                                                    target="_blank"
                                                    rel="noopener"
                                                    href={article.read_more_link}
                                                    className="text-decoration-none"
                                                >
                                                    Read More
                                                </a>
                                            </OutlinedButton>
                                        </div>
                                    </CardContent>
                                    {/* </div> */}
                                </Card>
                            ))
                        }

                        <div className="center">
                            <Typography
                                className="mtb10"
                            >
                                Viewing {current} of {total}
                            </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                className="sbutton"
                                onClick={handlePagination}
                            >
                                {
                                    current === total
                                        ? "View Less"
                                        : "View More"
                                }

                            </Button>
                        </div>
                    </div>
                </div>
            </BlockBox>

        </>
    )
}

export default Articles;